import { render, staticRenderFns } from "./nameDetail.vue?vue&type=template&id=04707f5e&scoped=true"
import script from "./nameDetail.vue?vue&type=script&lang=js"
export * from "./nameDetail.vue?vue&type=script&lang=js"
import style0 from "./nameDetail.vue?vue&type=style&index=0&id=04707f5e&prod&lang=scss"
import style1 from "./nameDetail.vue?vue&type=style&index=1&id=04707f5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04707f5e",
  null
  
)

export default component.exports